export interface Domain {
  /**
   * The domain name.
   */
  domainName: string | undefined;

  /**
   * The domain parent.
   */
  domainParent: string | undefined;

  /**
   * The domain parent name.
   */
  domainParentName: string | undefined;

  /**
   * The domain full name.
   */
  domainFullName: string | undefined;

  /**
   * The domain uuid.
   */
  domainUuid: string | undefined;

  /**
   * The domain sls name.
   */
  domainSlsName: string | undefined;

  /**
   * The open flag.
   */
  open: boolean;

  /**
   * The use user planning flag.
   */
  useUserPlanning: boolean;

  /**
   * The customer repository name configured for this domain.
   */
  customerRepositoryName: string | undefined;
}

export const initialDomain: Domain = {
  domainName: undefined,
  domainParent: undefined,
  domainParentName: undefined,
  domainFullName: undefined,
  domainUuid: undefined,
  domainSlsName: undefined,
  open: false,
  useUserPlanning: false,
  customerRepositoryName: undefined,
};

export const sortDomains = (a: Domain, b: Domain) => {
  if (!a.domainName || !b.domainName) {
    return 0;
  }
  const aDomainName = a.domainName.toUpperCase();
  const bDomainName = b.domainName.toUpperCase();
  if (aDomainName < bDomainName) {
    return -1;
  }
  if (aDomainName > bDomainName) {
    return 1;
  }
  return 0;
};
